import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_SUB_BENEFIT,
  RESET_BENEFIT_OTHER,
  RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT,
  RESET_BURIAL,
  RESET_REPATRIATION,
  RESET_PERSONAL_LIABILITY,
  RESET_PERSONAL_ACCIDENT,
  RESET_LOSS_OF_INCOME,
  RESET_TOTAL_PERMANENT_DISABLEMENT,
  RESET_LOSS_OF_LIFE,
} from './constants';
import { REPORT_TO } from '../StepOther/constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    isThereAnyThingElseYouWouldLikeToClaimFor: 'false',
    areYouClaimingForPersonalLiability: 'false',
    areYouClaimingForGolfPackOptionalCover: 'false',
    areYouClaimingForBicyclePackOptionalCover: 'false',
    areYouClaimingForAccidentalDeathAndDismemberment: 'false',
    areYouClaimingForRepatriationExpenses: 'false',
    areYouClaimingForBurialExpenses: 'false',
    personalLiabilitiesClaimDetail: {
      // howItHappened: '',
      // whereYouWereInRelationToTheItem: '',
      additional: '',
      // claimingFor: {
      //   loss: null,
      //   theft: null,
      //   damage: null,
      //   delay: null,
      // },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    anythingElse: {
      // howItHappened: '',
      // whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    golfPackOptionalClaimDetail: {
      howItHappened: '',
      whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    bicyclePackOptionalClaimDetail: {
      howItHappened: '',
      whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    personalLiabilitiesExpensesClaimed: [],
    golfPackOptionalExpensesClaimed: [],
    bicyclePackOptionalExpensesClaimed: [],
    anythingElseExpensesClaimed: [],
    // AD&D
    nameOfDeceased: '',
    dateOfInjury: '',
    theClaimIsBeingMadeUnder: '',
    placeWhereAccidentHappened: '',
    describeWhereTheAccidentOccurred: '',
    describeHowTheAccidentOccurred: '',
    checkNameOfDeceased: [],
    // RepatriationExpenses
    assistance: '',
    dateApproved: '',
    causeOfDeath: '',
    dateOfDeath: '',
    stateOfDeath: '',
    countryOfDeath: '',
    wasTheMemberHospitalized: 'false',
    fromDate: '',
    toDate: '',
    nameOfFuneralServiceProvider: '',
    costOfLocalBurial: '',
    invoice: '',
    amountClaimed: '',
    costOfLocalBurialCurrency: '',
    amountClaimedCurrency: '',
    familyMemberProvidingInformation: '',
    relationshipToMember: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    phoneNumber: '',
    // ForBurialExpense
    assistanceForBurial: '',
    dateApprovedForBurial: '',
    causeOfDeathForBurial: '',
    dateOfDeathForBurial: '',
    stateOfDeathForBurial: '',
    countryOfDeathForBurial: '',
    wasTheMemberHospitalizedForBurial: 'false',
    fromDateForBurial: '',
    toDateForBurial: '',
    nameOfFuneralServiceProviderForBurial: '',
    costOfLocalBurialForBurial: '',
    invoiceForBurial: '',
    amountClaimedForBurial: '',
    costOfLocalBurialCurrencyForBurial: '',
    amountClaimedCurrencyForBurial: '',
    familyMemberProvidingInformationForBurial: '',
    relationshipToMemberForBurial: '',
    addressForBurial: '',
    cityOrTownForBurial: '',
    countryForBurial: '',
    postalCodeForBurial: '',
    phoneNumberForBurial: '',
    enableTime: null,
    // Other SCTI
    whatExpensesAreYouClaimingFor: [],
    infoPersonalLiabilityItems: [],
    infoPersonalAccidentItems: [],
    whatAreYourExpensesRelatedTo: [],
    infoLossOfIncomeItems: [],
    infoTotalPermanentDisablementItems: [],
    infoLossOfLifeItems: [],
    dateYouWereOriginallyDueBackAtWork: '',
  },
  errors: [],
});

const initialADAndD = {
  form: {
    areYouClaimingForAccidentalDeathAndDismemberment: 'false',
    nameOfDeceased: '',
    dateOfInjury: '',
    theClaimIsBeingMadeUnder: '',
    placeWhereAccidentHappened: '',
    describeWhereTheAccidentOccurred: '',
    describeHowTheAccidentOccurred: '',
    checkNameOfDeceased: [],
  },
};

const initialRepatriationExpenses = {
  form: {
    areYouClaimingForRepatriationExpenses: 'false',
    assistance: '',
    dateApproved: '',
    causeOfDeath: '',
    dateOfDeath: '',
    stateOfDeath: '',
    countryOfDeath: '',
    wasTheMemberHospitalized: 'false',
    fromDate: '',
    toDate: '',
    nameOfFuneralServiceProvider: '',
    costOfLocalBurial: '',
    invoice: '',
    amountClaimed: '',
    costOfLocalBurialCurrency: '',
    amountClaimedCurrency: '',
    familyMemberProvidingInformation: '',
    relationshipToMember: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    phoneNumber: '',
  },
};

const initialBurialExpenses = {
  form: {
    areYouClaimingForBurialExpenses: 'false',
    assistanceForBurial: '',
    dateApprovedForBurial: '',
    causeOfDeathForBurial: '',
    dateOfDeathForBurial: '',
    stateOfDeathForBurial: '',
    countryOfDeathForBurial: '',
    wasTheMemberHospitalizedForBurial: 'false',
    fromDateForBurial: '',
    toDateForBurial: '',
    nameOfFuneralServiceProviderForBurial: '',
    costOfLocalBurialForBurial: '',
    invoiceForBurial: '',
    amountClaimedForBurial: '',
    costOfLocalBurialCurrencyForBurial: '',
    amountClaimedCurrencyForBurial: '',
    familyMemberProvidingInformationForBurial: '',
    relationshipToMemberForBurial: '',
    addressForBurial: '',
    cityOrTownForBurial: '',
    countryForBurial: '',
    postalCodeForBurial: '',
    phoneNumberForBurial: '',
  },
};

// const initialOptions = {
//   form: {
//     areYouClaimingForPersonalLiability: 'false',
//     areYouClaimingForGolfPackOptionalCover: 'false',
//     areYouClaimingForBicyclePackOptionalCover: 'false',
//     isThereAnyThingElseYouWouldLikeToClaimFor: 'false',
//     personalLiabilitiesClaimDetail: {
//       howItHappened: '',
//       whereYouWereInRelationToTheItem: '',
//       additional: '',
//       // claimingFor: {
//       //   loss: null,
//       //   theft: null,
//       //   damage: null,
//       //   delay: null,
//       // },
//       whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
//       otherDescription: '',
//       reportReferenceNumber: '',
//     },
//     anythingElse: {
//       // howItHappened: '',
//       // whereYouWereInRelationToTheItem: '',
//       additional: '',
//       // claimingFor: {
//       //   loss: null,
//       //   theft: null,
//       //   damage: null,
//       //   delay: null,
//       // },
//       whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
//       otherDescription: '',
//       reportReferenceNumber: '',
//     },
//     golfPackOptionalClaimDetail: {
//       howItHappened: '',
//       whereYouWereInRelationToTheItem: '',
//       additional: '',
//       claimingFor: {
//         loss: null,
//         theft: null,
//         damage: null,
//         delay: null,
//       },
//       whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
//       otherDescription: '',
//       reportReferenceNumber: '',
//     },
//     bicyclePackOptionalClaimDetail: {
//       howItHappened: '',
//       whereYouWereInRelationToTheItem: '',
//       additional: '',
//       // claimingFor: {
//       //   loss: null,
//       //   theft: null,
//       //   damage: null,
//       //   delay: null,
//       // },
//       whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
//       otherDescription: '',
//       reportReferenceNumber: '',
//     },
//     personalLiabilitiesExpensesClaimed: [],
//     golfPackOptionalExpensesClaimed: [],
//     bicyclePackOptionalExpensesClaimed: [],
//     anythingElseExpensesClaimed: [],
//   },
// };
const initialPersonalLiablity = {
  form: {
    areYouClaimingForPersonalLiability: 'false',
    personalLiabilitiesClaimDetail: {
      // howItHappened: '',
      // whereYouWereInRelationToTheItem: '',
      additional: '',
      // claimingFor: {
      //   loss: null,
      //   theft: null,
      //   damage: null,
      //   delay: null,
      // },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    personalLiabilitiesExpensesClaimed: [],
  },
};

const initialAnythingElse = {
  form: {
    isThereAnyThingElseYouWouldLikeToClaimFor: 'false',
    anythingElse: {
      // howItHappened: '',
      // whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    anythingElseExpensesClaimed: [],
  },
};

const initialPersonalLiability = {
  form: {
    infoPersonalLiabilityItems: [],
  },
};

const initialPersonalAccident = {
  form: {
    whatAreYourExpensesRelatedTo: [],
    infoPersonalAccidentItems: [],
    infoLossOfIncomeItems: [],
    infoTotalPermanentDisablementItems: [],
    infoLossOfLifeItems: [],
    dateYouWereOriginallyDueBackAtWork: '',
  },
};

const initialLossOfIncome = {
  form: {
    infoLossOfIncomeItems: [],
    dateYouWereOriginallyDueBackAtWork: '',
  },
};

const initialTotalPermanentDisablement = {
  form: {
    infoTotalPermanentDisablementItems: [],
  },
};

const initialLossOfLife = {
  form: {
    infoLossOfLifeItems: [],
  },
};

function stepOtherReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload ? fromJS({ form: action.payload, errors: [] }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_SUB_BENEFIT:
      return state.setIn(['form', 'personalLiabilitiesExpensesClaimed'], []).mergeDeep(initialPersonalLiablity);
    case RESET_BENEFIT_OTHER:
      return state.setIn(['form', 'anythingElseExpensesClaimed'], []).mergeDeep(initialAnythingElse);
    case RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT:
      return state.mergeDeep(initialADAndD);
    case RESET_REPATRIATION:
      return state.mergeDeep(initialRepatriationExpenses);
    case RESET_BURIAL:
      return state.mergeDeep(initialBurialExpenses);
    case RESET_PERSONAL_LIABILITY:
      return state
        .setIn(['form', 'infoPersonalLiabilityItems'], [])
        .mergeDeep(initialPersonalLiability);
    case RESET_PERSONAL_ACCIDENT:
      return state
        .setIn(['form', 'whatAreYourExpensesRelatedTo'], [])
        .setIn(['form', 'infoLossOfIncomeItems'], [])
        .setIn(['form', 'infoPersonalAccidentItems'], [])
        .setIn(['form', 'infoTotalPermanentDisablementItems'], [])
        .setIn(['form', 'infoLossOfLifeItems'], [])
        .mergeDeep(initialPersonalAccident);
    case RESET_LOSS_OF_INCOME:
      return state
        .setIn(['form', 'infoLossOfIncomeItems'], [])
        .mergeDeep(initialLossOfIncome);
    case RESET_TOTAL_PERMANENT_DISABLEMENT:
      return state
        .setIn(['form', 'infoTotalPermanentDisablementItems'], [])
        .mergeDeep(initialTotalPermanentDisablement);
    case RESET_LOSS_OF_LIFE:
      return state
        .setIn(['form', 'infoLossOfLifeItems'], [])
        .mergeDeep(initialLossOfLife);
    default:
      return state;
  }
}

export default stepOtherReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/reducer.js